import * as React from "react";
var MANAGEMENT_TYPES = [{
  value: "cotizacion",
  label: "Cotización enviada"
}, {
  value: "seguimiento",
  label: "Seguimiento comercial"
}, {
  value: "renovacion",
  label: "Renovación cerrada"
}, {
  value: "siniestro",
  label: "Siniestro"
}, {
  value: "otro",
  label: "Otro"
}];
var CONTACT_METHODS = [{
  value: "email",
  label: "Email"
}, {
  value: "telefono",
  label: "Teléfono"
}, {
  value: "whatsapp",
  label: "WhatsApp"
}, {
  value: "reunion",
  label: "Reunión"
}, {
  value: "presencial",
  label: "Presencial"
}];
var STATUS_OPTIONS = [{
  value: "pendiente",
  label: "Pendiente"
}, {
  value: "en_proceso",
  label: "En proceso"
}, {
  value: "cerrado",
  label: "Cerrado"
}];

var CommentFileForm = function CommentFileForm(props) {
  var onSubmit = props.onSubmit,
      fileTypes = props.fileTypes,
      _props$initialData = props.initialData,
      initialData = _props$initialData === void 0 ? {} : _props$initialData,
      onCancel = props.onCancel; // Refs para comentario

  var commentTextareaRef = React.useRef(null);
  var commentNextStepRef = React.useRef(null);
  var commentManagementTypeRef = React.useRef(null);
  var commentContactMethodRef = React.useRef(null);
  var commentStatusRef = React.useRef(null); // Refs para archivo

  var fileInputRef = React.useRef(null);
  var fileTypeRef = React.useRef(null);
  React.useEffect(function () {
    // Inicializar valores del comentario
    if (initialData.comment) {
      if (commentTextareaRef.current && initialData.comment.content) {
        commentTextareaRef.current.value = initialData.comment.content;
      }

      if (commentNextStepRef.current && initialData.comment.next_step) {
        commentNextStepRef.current.value = initialData.comment.next_step;
      }

      if (commentManagementTypeRef.current && initialData.comment.management_type) {
        commentManagementTypeRef.current.value = initialData.comment.management_type;
      }

      if (commentContactMethodRef.current && initialData.comment.contact_method) {
        commentContactMethodRef.current.value = initialData.comment.contact_method;
      }

      if (commentStatusRef.current && initialData.comment.status) {
        commentStatusRef.current.value = initialData.comment.status;
      }
    } // Inicializar valores del archivo


    if (initialData.file) {
      if (fileTypeRef.current && initialData.file.file_type) {
        fileTypeRef.current.value = initialData.file.file_type;
      }
    }
  }, [initialData]);

  var handleSubmit = function handleSubmit(e) {
    var _commentTextareaRef$c, _commentTextareaRef$c2, _fileInputRef$current, _fileInputRef$current2, _fileTypeRef$current;

    e.preventDefault();
    var commentContent = ((_commentTextareaRef$c = commentTextareaRef.current) === null || _commentTextareaRef$c === void 0 ? void 0 : (_commentTextareaRef$c2 = _commentTextareaRef$c.value) === null || _commentTextareaRef$c2 === void 0 ? void 0 : _commentTextareaRef$c2.trim()) || "";
    var file = (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : (_fileInputRef$current2 = _fileInputRef$current.files) === null || _fileInputRef$current2 === void 0 ? void 0 : _fileInputRef$current2[0];
    var fileType = ((_fileTypeRef$current = fileTypeRef.current) === null || _fileTypeRef$current === void 0 ? void 0 : _fileTypeRef$current.value) || ""; // Al menos uno debe estar presente

    if (!commentContent && !file) {
      alert("Por favor, ingrese un comentario o seleccione un archivo");
      return;
    } // Si hay archivo, debe tener tipo


    if (file && !fileType) {
      alert("Por favor, seleccione un tipo de archivo");
      return;
    }

    var submitData = {}; // Preparar datos del comentario si existe

    if (commentContent) {
      var _commentManagementTyp, _commentContactMethod, _commentNextStepRef$c, _commentNextStepRef$c2, _commentStatusRef$cur;

      var managementType = (_commentManagementTyp = commentManagementTypeRef.current) === null || _commentManagementTyp === void 0 ? void 0 : _commentManagementTyp.value;
      var contactMethod = (_commentContactMethod = commentContactMethodRef.current) === null || _commentContactMethod === void 0 ? void 0 : _commentContactMethod.value;
      var nextStep = (_commentNextStepRef$c = commentNextStepRef.current) === null || _commentNextStepRef$c === void 0 ? void 0 : (_commentNextStepRef$c2 = _commentNextStepRef$c.value) === null || _commentNextStepRef$c2 === void 0 ? void 0 : _commentNextStepRef$c2.trim();
      var status = (_commentStatusRef$cur = commentStatusRef.current) === null || _commentStatusRef$cur === void 0 ? void 0 : _commentStatusRef$cur.value;
      submitData.comment = {
        content: commentContent,
        management_type: managementType && managementType.trim() !== "" ? managementType : undefined,
        contact_method: contactMethod && contactMethod.trim() !== "" ? contactMethod : undefined,
        next_step: nextStep && nextStep.trim() !== "" ? nextStep : undefined,
        status: status && status.trim() !== "" ? status : undefined
      };
    } // Preparar datos del archivo si existe


    if (file && fileType) {
      submitData.file = {
        file: file,
        file_type: fileType
      };
    }

    onSubmit(submitData); // Limpiar formulario

    if (commentTextareaRef.current) commentTextareaRef.current.value = "";
    if (commentNextStepRef.current) commentNextStepRef.current.value = "";
    if (commentManagementTypeRef.current) commentManagementTypeRef.current.value = "";
    if (commentContactMethodRef.current) commentContactMethodRef.current.value = "";
    if (commentStatusRef.current) commentStatusRef.current.value = "";
    if (fileInputRef.current) fileInputRef.current.value = "";
    if (fileTypeRef.current) fileTypeRef.current.value = "";
  };

  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit,
    style: {
      display: "flex",
      flexDirection: "column",
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "8px",
      padding: "12px",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      margin: "0"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3",
    style: {
      paddingRight: "4px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: "0"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      marginBottom: "3px",
      fontSize: "13px",
      fontWeight: "bold"
    }
  }, "Comentario (Opcional)"), /*#__PURE__*/React.createElement("textarea", {
    ref: commentTextareaRef,
    className: "form-control",
    rows: 4,
    placeholder: "Escribe tu comentario...",
    style: {
      fontSize: "10px",
      resize: "vertical",
      padding: "4px 8px",
      minHeight: "80px",
      lineHeight: "1.4",
      maxWidth: "200px"
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3",
    style: {
      paddingLeft: "4px",
      paddingRight: "4px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      marginBottom: "3px",
      fontSize: "13px",
      fontWeight: "bold"
    }
  }, "Tipo de Gesti\xF3n"), /*#__PURE__*/React.createElement("select", {
    ref: commentManagementTypeRef,
    className: "form-control",
    style: {
      fontSize: "10px",
      padding: "4px 8px",
      height: "32px",
      maxWidth: "150px"
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Seleccione un tipo"), MANAGEMENT_TYPES.map(function (type) {
    return /*#__PURE__*/React.createElement("option", {
      key: type.value,
      value: type.value
    }, type.label);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: "0"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      marginBottom: "3px",
      fontSize: "13px",
      fontWeight: "bold"
    }
  }, "Estado"), /*#__PURE__*/React.createElement("select", {
    ref: commentStatusRef,
    className: "form-control",
    style: {
      fontSize: "10px",
      padding: "4px 8px",
      height: "32px",
      maxWidth: "150px"
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Seleccione un estado"), STATUS_OPTIONS.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3",
    style: {
      paddingLeft: "4px",
      paddingRight: "4px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      marginBottom: "3px",
      fontSize: "13px",
      fontWeight: "bold"
    }
  }, "Medio de Contacto"), /*#__PURE__*/React.createElement("select", {
    ref: commentContactMethodRef,
    className: "form-control",
    style: {
      fontSize: "10px",
      padding: "4px 8px",
      height: "32px",
      maxWidth: "150px"
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Seleccione un medio"), CONTACT_METHODS.map(function (method) {
    return /*#__PURE__*/React.createElement("option", {
      key: method.value,
      value: method.value
    }, method.label);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: "0"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      marginBottom: "3px",
      fontSize: "13px",
      fontWeight: "bold"
    }
  }, "Pr\xF3ximo Paso"), /*#__PURE__*/React.createElement("input", {
    ref: commentNextStepRef,
    type: "text",
    className: "form-control",
    placeholder: "Ej: Esperar respuesta del cliente",
    style: {
      fontSize: "10px",
      padding: "4px 8px",
      height: "32px",
      maxWidth: "150px"
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3",
    style: {
      paddingLeft: "4px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      marginBottom: "3px",
      fontSize: "13px",
      fontWeight: "bold"
    }
  }, "Tipo de archivo"), /*#__PURE__*/React.createElement("select", {
    ref: fileTypeRef,
    className: "form-control",
    style: {
      fontSize: "10px",
      padding: "4px 8px",
      height: "32px",
      maxWidth: "150px"
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Seleccione un tipo"), fileTypes.map(function (type) {
    return /*#__PURE__*/React.createElement("option", {
      key: type.value,
      value: type.value
    }, type.label);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: "0"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      marginBottom: "3px",
      fontSize: "13px",
      fontWeight: "bold"
    }
  }, "Archivo (Opcional)"), /*#__PURE__*/React.createElement("input", {
    ref: fileInputRef,
    type: "file",
    className: "form-control",
    accept: ".pdf",
    style: {
      fontSize: "10px",
      padding: "4px 8px",
      height: "32px",
      maxWidth: "150px"
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "auto",
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: "6px"
    }
  }, onCancel && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-secondary btn-xs",
    onClick: onCancel,
    style: {
      padding: "6px 12px",
      fontSize: "15px",
      height: "auto"
    }
  }, "Cancelar"), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-primary btn-xs",
    style: {
      padding: "3px 8px",
      fontSize: "10px",
      height: "24px"
    }
  }, "Guardar")));
};

export default CommentFileForm;